import styled from "styled-components";

export const StyledBulkAddContainer = styled.div`
    margin-top: 24px;
`;
